import { GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import PartnerWebinars from '../../components/PartnerWebinars';
import fetchUtil from '../../utils/fetchUtil';

const Webinars: React.FC = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#313145');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <PartnerWebinars {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-webinar-kc-landing`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default Webinars;